import * as React from 'react';

import type { HeadProps, PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { CtaBlock } from 'stile-shared/src/components/2020/blocks/CtaBlock';
import { HeroBlock } from 'stile-shared/src/components/2020/blocks/HeroBlock';
import { TextBlock } from 'stile-shared/src/components/2020/blocks/TextBlock';
import { P } from 'stile-shared/src/components/2020/common/Primitives';
import { TypeformEmbed } from 'stile-shared/src/components/2020/common/TypeformEmbed';

import { PageLayout } from 'templates/2020/PageLayout';
import { SEO } from 'templates/2020/SEO';

export function Head(props: HeadProps) {
  return (
    <SEO
      title="Your planning is done with Stile"
      description="Take the night off and enjoy a movie on us!"
      slug={props.location.pathname}
    />
  );
}

function HomePage(props: PageProps) {
  return (
    <PageLayout {...props}>
      <HeroBlock
        title="Your planning is done with Stile"
        text="Take the night off and enjoy a movie on us!"
        image={
          <StaticImage
            src="../../../stile-shared/assets/images/planning-is-done/planning_is_done_cover.png"
            alt=""
          />
        }
      />

      <TextBlock stretch>
        <P>Fill out the form below to redeem cinema tickets.</P>
        <TypeformEmbed id="c1XujN4y" />
      </TextBlock>

      <CtaBlock />
    </PageLayout>
  );
}

export default HomePage;
